// init header lang selector
var headerLangForm = document.querySelector('.header-selectors-form');
var headerLangSelector = document.querySelector('.header-lang-selector');
var headerLangList = document.querySelector('.header-lang-list');
var headerLangListOptions = headerLangList.querySelectorAll('a');

headerLangSelector.addEventListener('click', function() {
	headerLangList.classList.toggle('reveal');
});

headerLangListOptions.forEach(option => {
	option.addEventListener('click', function() {
		var langInput = document.querySelector('#LocaleSelector--header');

		langInput.value = option.dataset.value;

		headerLangForm.submit();
	})
})